<template>
  <div>
       <div class="weui-mask_transparent"></div>
       <div class="weui-toast">
           <i class="weui-loading weui-icon_toast"></i>
           <p class="weui-toast__content">{{msg}}</p>
       </div>
   </div>
</template>

<script>
  export default{
    props:['msg']
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/LoadingToast.vue